/* eslint-disable react/jsx-no-target-blank */

import React from 'react'

const Banner = () => {



    return (
        <>
            <section id="home" class="banner-slider-initial">
                {/* <!--slider--> */}
                <div class="banner">
                    <div class="" id="banner-slide-show">
                        <div class="">
                            <div class="banner-home">
                                <div class="banner-text">
                                    <span class="much-img"><img src="./images/slider-icon.png" alt="" /></span>
                                    <span>we make your hair</span>
                                    <h1>Achive style</h1>
                                    <p>The best place for your hairstyleLorem Ipsum is simply dummytext.</p>
                                    <a href="https://booksy.com/en-ca/17648_kaz-barbershop_barbershop_944431_toronto?do=invite&_branch_match_id=1245673143711658967&utm_medium=merchant_customer_invite&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVdw0OzPBOq7J0cU0CAHN%2Fv7giAAAA" target='_blank' rel='https://booksy.com/en-ca/17648_kaz-barbershop_barbershop_944431_toronto?do=invite&_branch_match_id=1245673143711658967&utm_medium=merchant_customer_invite&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVdw0OzPBOq7J0cU0CAHN%2Fv7giAAAA' title="Make an appointment" class="slider-more-btn">Make an appointment</a>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </section>
            <div class="container">
                <div class="row">
                    <div class="timing-section" >
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="timing-section-box">
                                <div class="timing-section-icon" >
                                    <i class="icofont icofont-location-pin"></i>
                                </div>
                                <div class="timing-section-text" >
                                    70 Yorkville Ave, Toronto, ON M5R 1B9, Unit LR3
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="timing-section-box border-left-right">
                                <div class="timing-section-icon" >
                                    <i class="icofont icofont-telephone"></i>
                                </div>
                                <div class="timing-section-text" >
                                    (416) 972-0333
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="timing-section-box">
                                <div class="timing-section-icon" >
                                    <i class="icofont icofont-wall-clock"></i>
                                </div>
                                <div class="timing-section-text" >
                                    Monday - Satuarday:  09.00 AM - 8:00 PM
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Banner